'use client';

import { SessionProvider } from 'next-auth/react';
import { ThemeProvider } from '@/context/ThemeContext';
import { Toaster } from 'react-hot-toast';

export function Providers({ 
  children, 
  session 
}: { 
  children: React.ReactNode; 
  session?: any 
}) {
  return (
    <SessionProvider session={session}>
      <ThemeProvider>
        {children}
        <Toaster position="top-right" />
      </ThemeProvider>
    </SessionProvider>
  );
} 